import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './BecomeDealer.css';

const BecomeDealer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const features = [
    t('dealer.feature_rights'),
    t('dealer.feature_margins'),
    t('dealer.feature_support'),
    t('dealer.feature_stock')
  ];

  const stats = [
    {
      value: '250+',
      label: t('dealer.active_dealers'),
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      )
    },
    {
      value: '38',
      label: t('dealer.districts_covered'),
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="8" r="7" />
          <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88" />
        </svg>
      )
    },
    {
      value: '150+',
      label: t('dealer.product_range'),
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
          <polyline points="17 6 23 6 23 12" />
        </svg>
      )
    },
    {
      value: '50K+',
      label: t('dealer.farmers_served'),
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
          <polyline points="9 22 9 12 15 12 15 22" />
        </svg>
      )
    }
  ];

  return (
    <section className="become-dealer-section">
      <div className="container">
        <div className="dealer-section-grid">
          
          {/* Left Column - Copy & CTA */}
          <div className="dealer-content-left">
            <span className="partnership-badge">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
              {t('dealer.partnership_opportunity')}
            </span>
            
            <h2 className="dealer-title">{t('dealer.become_dealer')}</h2>
            <p className="dealer-desc">
              {t('dealer.dealer_desc')}
            </p>
            
            <ul className="dealer-features-list">
              {features.map((feature, i) => (
                <li key={i} className="dealer-feature-item">
                  <div className="feature-check-icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </div>
                  <span className="feature-text">{feature}</span>
                </li>
              ))}
            </ul>
            
            <div className="dealer-actions-row">
              <button className="btn-dealer-apply" onClick={() => navigate('/apply')}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M16 11V7a3 3 0 0 0-6 0v4M12 2v2M8 12a4 4 0 0 0 8 0" />
                </svg>
                {t('dealer.apply_now')}
              </button>
              
              <button className="btn-dealer-call" onClick={() => window.open('tel:+91 96312 77264', '_self')}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l2.27-2.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                {t('dealer.call_us')}
              </button>
            </div>
          </div>
          
          {/* Right Column - 2x2 Grid of Stat Cards */}
          <div className="dealer-stats-grid">
            {stats.map((stat, i) => (
              <div key={i} className="dealer-stat-card">
                <div className="dealer-stat-icon-wrap">
                  {stat.icon}
                </div>
                <h3 className="dealer-stat-value">{stat.value}</h3>
                <p className="dealer-stat-label">{stat.label}</p>
              </div>
            ))}
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default BecomeDealer;


